import React from 'react';
import ReactJson from 'react-json-view';
import { Box, Typography, Paper } from '@mui/material';

function RetrievalResults({ retrievalResults }) {
  return (
    <Box sx={{ width: '90%', margin: '20px auto', padding: '24px' }}>
      <Paper elevation={3} sx={{ padding: '20px', borderRadius: '10px' }}>
        <Typography variant="h5" gutterBottom>
          Retrieval Results
        </Typography>
        <ReactJson 
          src={retrievalResults} 
          name={false}
          collapsed={2}  // Start with 2 levels collapsed
          enableClipboard={true}
          displayDataTypes={false}
          style={{ fontSize: "14px" }}
          theme="rjv-default"
        />
      </Paper>
    </Box>
  );
}

export default RetrievalResults;